<template>
  <section id="main-content">
    <section class="wrapper">
      <section class="login container-fluid" :style="{ background: background }">
        <div class="container box-login" :style="{ '--background-url': 'url(' + imagem + '), url(' + imagemPadrao + ')' }">
          <div class="row">
            <div class="col-12 col-md-6 text-center">
              <h1>{{ textoFacaSeuLogin }}</h1>
            </div>
            <div class="col-12 col-md-6 col-form">
              <form method="POST" v-on:submit.prevent="login()" class="form-login">
                <div class="form-group">
                  <label class="sr-only" for="email">Email</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text text-center"><i class="far fa-envelope"></i></div>
                    </div>
                    <input type="email" class="form-control" id="email" placeholder="e-mail" name="email"
                           v-model="email" required autofocus>
                  </div>
                </div>
                <div class="form-group mb-4">
                  <label class="sr-only" for="password">Senha</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text text-center"><i class="fas fa-unlock-alt"></i></div>
                    </div>
                    <input type="password" id="password" placeholder="senha" class="form-control" name="password"
                           v-model="senha" required>
                  </div>

                  <div class="invalid-feedback" v-if="erroLogin">
                    {{ erroLogin }}
                  </div>

                  <small class="form-text text-muted mt-3">Esqueceu a senha? <a @click="$router.push('/login/recuperar-senha')" href="javascript:void(0)">Recupere agora mesmo</a>
                  </small>
                </div>
                <br>
                <button type="submit" class="btn btn-primary mb-2 btn-login" :disabled="submitLogin">
                  <template v-if="submitLogin">
                    <i class="fas fa-spinner fa-spin"></i>
                  </template>
                  <template v-else>
                    Fazer login
                  </template>
                </button>
                <p>Não tem uma conta? Entre em contato com um administrador da sua instituição.</p>
              </form>
            </div>
          </div>
        </div>
        <modal-limite-sessao/>
        <modal-limite-dispositivos/>
      </section>
    </section>
    <voll-chat />
  </section>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import LoginUtils from '@/core/utils/login-utils'
import ResponseUtils from '@/core/utils/response-utils'
import PerfilAPI from '@/api/perfil-api'
import { v4 as uuidv4 } from 'uuid'
import VollChat from '@/core/components/chat/VollChat'
import ModalLimiteSessao from '@/components/ModalLimiteSessao'
import ModalLimiteDispositivos from '@/components/ModalLimiteDispositivos'

export default {
  name: 'LoginView',
  components: { VollChat, ModalLimiteSessao, ModalLimiteDispositivos },
  data () {
    return {
      submitLogin: false,
      erroLogin: null,
      email: '',
      senha: '',
      imagem: '',
      background: '',
      textoFacaSeuLogin: '',
      uuidLs: null,
      uuid: uuidv4()
    }
  },

  created () {
    this.imagemPadrao = require('@/assets/img/bg-login.png')
    this.imagem = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/bgLogin.png`
    this.textoFacaSeuLogin = this.$configEmpresa.textosConfiguraveis.textoFacaSeuLogin
    this.background = this.$configEmpresa.login.background

    document.body.classList.add('login')
  },

  mounted () {
    this.setarDadosNoLocalStorage()
  },

  watch: {
    uuidLs (novoValor, antigoValor) {
      localStorage.setItem('uuidLs', JSON.stringify(novoValor))
    }
  },

  destroyed () {
    document.body.classList.remove('login')
  },

  methods: {
    login: async function () {
      this.erroLogin = null
      this.submitLogin = true

      try {
        const token = await UsuarioAPI.login(this.email, this.senha).then(data => data.access_token)
        LoginUtils.setToken(token)

        const usuario = await UsuarioAPI.obterUsuario().then(data => {
          let usuario = data.user
          usuario.planos = data.plano
          usuario.planoPrincipal = data.planoPrincipal
          usuario.perfilUsuario = data.user.perfil

          return usuario
        }).catch(e => {
          this.showLoginError(e)
        })

        if (usuario) {
          const perfil = await PerfilAPI.obterPerfil()
          if (perfil) {
            usuario.perfil = perfil
          }

          LoginUtils.setUsuario(usuario)

          window.location = this.$route.query.redir ? this.$route.query.redir : '/home'
        }
      } catch (e) {
        this.showLoginError(e)
      }
    },

    showLoginError: function (e) {
      this.submitLogin = false

      const errorData = ResponseUtils.getErrorData(e)
      if (errorData && errorData.error === 'too_many_attempts') {
        this.erroLogin = errorData.error_description
      } else if (errorData && errorData.message) {
        this.erroLogin = errorData.message
      } else {
        this.erroLogin = 'Ocorreu um erro inesperado, por favor entre em contato com o administrador do sistema.'
      }

      LoginUtils.logout()
    },

    setarDadosNoLocalStorage: function () {
      if (this.uuidLs == null) {
        this.uuidLs = this.uuid
      }
    }
  }
}
</script>

<style scoped>
  .invalid-feedback {
    display: block;
  }

  .form-login {
    padding-top: 40%;
  }

  @media (max-width: 936px) {
    .form-login {
      padding-top: 0px;
    }
  }

  .box-login {
    background: var(--background-url);
  }
</style>
